import { FilterGroup } from './filters.model';

export enum SortDirection {
  Ascending,
  Descending
};

export interface QueryParams {
  skip?: number;
  take?: number;
  where?: string;
  sortField?: string;
  sortDirection?: string | SortDirection;
  sort?: string;
  include?: string;
  totalCount?: number;
  searchTerm?: string;
}

export interface QueryParamsForSelection extends QueryParams {
  thenSortField?: string;
  thenSortDirection?: string;
  selected?: string[];
  selectedOnly?: boolean;
}

export const queryParamsFromResult = (result: QueryResult<any>) => {
  return {
    skip: result?.skip,
    take: result?.take,
    where: result?.where,
    sortField: result?.sortField,
    sortDirection: result?.sortDirection,
    sort: result?.sort,
    include: result?.include,
    totalCount: result?.totalCount,
    searchTerm: result?.searchTerm
  };
};

export interface QueryResult<T> extends QueryParams {
  data?: T[];
  totalCount?: number;
}

export interface DocumentQueryParams {
  filterGroup: FilterGroup;
  calcFields?: CalcField[];
  fields: string;
  sort?: string;
  group?: string;
  pagination: DocumentQueryPagination;
  selected?: string[];
}

export interface CalcField {
  name: string;
  calc: CalcOperation;
}

export interface CalcOperation {
  operator: CalcFieldOperator;
  expressions?: string[];
}

export enum CalcFieldOperator {
  None = 0,
  DistanceByWkt = 1,
  IntersectsWkt = 2,
  DatePart = 3
}

export interface DocumentQueryPagination {
  skip: number;
  take: number;
  options?: any;
}

export interface LayerDocumentsInClickRadiusRequest {
  layers: LayerWithFilterGroupDto[];
  latitude: number;
  longitude: number;
  pixelSizeInMeters: number;
  selectedFloor: string;
}

export interface LayerWithFilterGroupDto {
  layerUId: string;
  datasetUId: string;
  filterGroup: FilterGroup;
  floorFilterSourceField?: string;
}
